export const LOCAL_STORAGE_KEY = {
  useDeviceAuth: "useDeviceAuth",
  accessToken: "accessToken",
  refreshToken: "refreshToken",
  androidToken: "androidToken",
  client: "client",
  deviceId: "deviceId",
  deviceIdLocal: "deviceIdLocal",
  theme: "theme",
  username: "username",
  saveUsername: "saveUsername",
  private: "private",
  path: "path",
  version: "version",
  language: "i18nextLng",
  offeneAufgaben: "offeneAufgaben",
  modulGruppenfilter1: "modulGruppenfilter1",
  modulGruppenfilter2: "modulGruppenfilter2",
  AbsenceArchData: "AbsenceArchData",
  AbsenceArchFilter: "AbsenceArchFilter",
  kalenderJahresAnsicht: "kalprio",
  formular: "formular",
  form_showLohnarten: "form_showLohnarten",
  selectedMenu: "selectedMenu",
};
